module.exports = __webpack_public_path__ + "media/buy-now/sample_box9-641d6233.png";